import type { TaskDto } from '@schwrz/shared';
import { compareDueTime } from '@schwrz/shared';

/**
 * Comparator matching the API list order:
 * `done asc, dueDate asc, dueTime asc, sortOrder asc, createdAt asc`
 * (see tasks.routes.ts `orderBy`).
 */
export function compareTasks(a: TaskDto, b: TaskDto): number {
  if (a.done !== b.done) return a.done ? 1 : -1;

  const aDue = a.dueDate;
  const bDue = b.dueDate;
  if (aDue !== bDue) {
    if (aDue === null) return bDue === null ? 0 : -1;
    if (bDue === null) return 1;
    return aDue.localeCompare(bDue);
  }

  const timeCmp = compareDueTime(a.dueTime, b.dueTime);
  if (timeCmp !== 0) return timeCmp;

  if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder;
  return a.createdAt.localeCompare(b.createdAt);
}

/** Insert `task.id` into an id list sorted by {@link compareTasks}. */
export function insertTaskIdSorted(ids: string[], task: TaskDto, records: Map<string, TaskDto>): string[] {
  const without = ids.filter((id) => id !== task.id);
  const insertAt = without.findIndex((id) => {
    const other = records.get(id);
    return other ? compareTasks(task, other) < 0 : false;
  });
  if (insertAt === -1) return [...without, task.id];
  return [...without.slice(0, insertAt), task.id, ...without.slice(insertAt)];
}
